/* eslint-disable @typescript-eslint/naming-convention */
import { DiscoverRouteTypeEnum } from '../../DiscoverRouter/enums/discover-route-type.enum';

export enum FullProfileContextEnum {
    CONTACT = 'CONTACT',
    REPORT = 'REPORT',
    SEARCH = 'SEARCH',
    LIST = 'LIST',
    NONE = 'NONE'
}

export const FullProfileContextEnumToLocalizationTokenMap: Map<FullProfileContextEnum, string> = new Map([
    [FullProfileContextEnum.CONTACT, 'Discover.entityFullProfile.backToForm'],
    [FullProfileContextEnum.REPORT, 'Discover.entityFullProfile.backToReport'],
    [FullProfileContextEnum.SEARCH, 'Discover.entityFullProfile.backToSearch'],
    [FullProfileContextEnum.LIST, 'Discover.entityFullProfile.backToList'],
    [FullProfileContextEnum.NONE, 'Discover.entityFullProfile.backToProfile']
]);

export const DiscoverRouteTypeEnumToFullProfileContextEnumMap: Map<DiscoverRouteTypeEnum, FullProfileContextEnum> = new Map([
    [DiscoverRouteTypeEnum.contactEditor, FullProfileContextEnum.CONTACT],
    [DiscoverRouteTypeEnum.distributionReport, FullProfileContextEnum.REPORT],
    [DiscoverRouteTypeEnum.targetingResults, FullProfileContextEnum.SEARCH],
    [DiscoverRouteTypeEnum.targetingSavedSearchResults, FullProfileContextEnum.SEARCH],
    [DiscoverRouteTypeEnum.targetingSavedSearch, FullProfileContextEnum.SEARCH],
    [DiscoverRouteTypeEnum.privateContacts, FullProfileContextEnum.LIST],
    [DiscoverRouteTypeEnum.targetingListSearchResult, FullProfileContextEnum.LIST],
    [DiscoverRouteTypeEnum.contactProfile, FullProfileContextEnum.NONE],
    [DiscoverRouteTypeEnum.outletProfile,  FullProfileContextEnum.NONE],
    [DiscoverRouteTypeEnum.influencerStreams, FullProfileContextEnum.SEARCH]
]);
